// extracted by mini-css-extract-plugin
export default {"TabDeleteButton":"TabDeleteButton_TabDeleteButton__G4KS+","DeleteIcon":"TabDeleteButton_DeleteIcon__80Rav"};